import { Component, Input, Output } from '@angular/core';

@Component({
  selector: 'app-system-stats',
  templateUrl: './system-stats.component.html',
  styleUrls: ['./system-stats.component.less']
})
export class SystemStatsComponent  {

  constructor() { }

  @Input() machineList: any =[] 

  isCollapsed = true
  
  

  toggleStatTable = ():void =>{
     this.isCollapsed = !this.isCollapsed
  }

}
